// SubmissionProgress.jsx
import React from 'react';

const SubmissionProgress = () => (
  <div className="submission-progress">
    Saving structure (only new items)... This may take a moment.
  </div>
);

export default SubmissionProgress;